module.exports = __webpack_public_path__ + "static/05-672773ff45248b43c7f05ac77639d9be.png";